"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
/*
* All possible states reflecting Whatsapp Integration
* Configuring - Getting password
* Ready - Ready to use.
* Error - Something wrong happend
*/
var WhatsApptatus;
(function (WhatsApptatus) {
    WhatsApptatus["Requested"] = "REQUESTED";
    WhatsApptatus["SmsSent"] = "SMS_SENT";
    WhatsApptatus["SmsCodeSaved"] = "SMS_CODE_SAVED";
    WhatsApptatus["Ready"] = "READY";
    WhatsApptatus["Error"] = "ERROR"; // Algo errado ocorreu, ver propriedade errorMessage
})(WhatsApptatus = exports.WhatsApptatus || (exports.WhatsApptatus = {}));
var RoutingRuleType;
(function (RoutingRuleType) {
    // The customer will be routed based on his phone number (chatId) using regex expression
    // the teamId must be present.
    // Example DDD from MG ^552(1|2|3)[0-9]{9}$
    RoutingRuleType["ChatIdToTeam"] = "CHAT_ID_TO_TEAM";
})(RoutingRuleType = exports.RoutingRuleType || (exports.RoutingRuleType = {}));
class WhatsApp extends Parse.Object {
    constructor(attributes) {
        super('WhatsApp', attributes);
    }
    /** Integration status  */
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
    /** SMS code sent by WhatsApp */
    get whatsappCode() { return this.get('whatsappCode'); }
    set whatsappCode(value) { this.set('whatsappCode', value); }
    /** If  status === 'ERROR', it will contain more details about the error */
    get errorMessage() { return this.get('errorMessage'); }
    set errorMessage(value) { this.set('errorMessage', value); }
    /* 5541991012421 */
    get retailerId() { return this.get('retailerId'); }
    set retailerId(value) { this.set('retailerId', value); }
    get greetingMessageEnabled() { return this.get('greetingMessageEnabled'); }
    set greetingMessageEnabled(value) { this.set('greetingMessageEnabled', value); }
    get greetingMessage() { return this.get('greetingMessage'); }
    set greetingMessage(value) { this.set('greetingMessage', value); }
    get afterHoursMessageEnabled() { return this.get('afterHoursMessageEnabled'); }
    set afterHoursMessageEnabled(value) { this.set('afterHoursMessageEnabled', value); }
    get tradingHours() { return this.get('tradingHours'); }
    set tradingHours(value) { this.set('tradingHours', value); }
    get afterHoursMessage() { return this.get('afterHoursMessage'); }
    set afterHoursMessage(value) { this.set('afterHoursMessage', value); }
    get profilePicture() { return this.get('profilePicture'); }
    set profilePicture(value) { this.set('profilePicture', value); }
    get phoneAreaCode() { return this.get('phoneAreaCode'); }
    set phoneAreaCode(value) { this.set('phoneAreaCode', value); }
    get phoneNumber() { return this.get('phoneNumber'); }
    set phoneNumber(value) { this.set('phoneNumber', value); }
    // Temporário
    get whatsappWebConnector() { return this.get('whatsappWebConnector'); }
    set whatsappWebConnector(value) { this.set('whatsappWebConnector', value); }
    get whatsappConnectorUrl() { return this.get('whatsappConnectorUrl'); }
    set whatsappConnectorUrl(value) { this.set('whatsappConnectorUrl', value); }
    get routingRules() { return this.get('routingRules'); }
    set routingRules(value) { this.set('routingRules', value); }
    // New contacts will be assigned to this team
    get defaultTeam() { return this.get('defaultTeam'); }
    set defaultTeam(value) { this.set('defaultTeam', value); }
    // If the sales person name will be added in the begining of all messages sent to customers
    // Default is true
    get showSalerPersonName() { return this.get('showSalerPersonName'); }
    set showSalerPersonName(value) { this.set('showSalerPersonName', value); }
    get blockedIds() { return this.get('blockedIds'); }
    set blockedIds(value) { this.set('blockedIds', value); }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get allowCreateInternatinalChats() { return this.get('allowCreateInternatinalChats'); }
    set allowCreateInternatinalChats(value) { this.set('allowCreateInternatinalChats', value); }
    // If the sales person name will be added in the begining of all messages sent to customers
    // Default is true
    get hasBot() { return this.get('hasBot'); }
    set hasBot(value) { this.set('hasBot', value); }
    // If true, the WhatsAppAdapter will only reply with the migratedToWABMessage
    get isMigratedToWAB() { return this.get('isMigratedToWAB'); }
    set isMigratedToWAB(value) { this.set('isMigratedToWAB', value); }
    // The message that will be presented to the user when isMigratedToWAB is true
    get migratedToWABMessage() { return this.get('migratedToWABMessage'); }
    set migratedToWABMessage(value) { this.set('migratedToWABMessage', value); }
}
exports.WhatsApp = WhatsApp;
Parse.Object.registerSubclass('WhatsApp', WhatsApp);
//# sourceMappingURL=WhatsApp.js.map